import { defineMessages } from 'react-intl'

export default defineMessages({
  disabledUser: {
    id: 'context.Profile.disabledUser',
    defaultMessage: 'You do not have the right to perform this action',
  },
  trialEnded: {
    id: 'context.Profile.trialEnded',
    defaultMessage: 'Your trial account is done. Contact Nfinite to continue your experience',
  },
  accessDenied: {
    id: 'context.Profile.accessDenied',
    defaultMessage: 'You can not access to this content',
  },
})
